import { render } from "./ProfileIndex.vue?vue&type=template&id=f1d0ef9c"
import script from "./ProfileIndex.vue?vue&type=script&lang=js"
export * from "./ProfileIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__